<template>
  <div>
    <div v-if="this.checkMobile()" class="grey-background-container">
      <MobileNavigationBack
        :moduleRoute="moduleRoute"
        :appbarTitle="appbarTitle"
      ></MobileNavigationBack>
      <br />
      <br />

      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div
          id="dataPanel"
          class="bg-white overflow-hidden px-3 shadow-xl sm:rounded-lg"
        >
          <div class="row pt-3 px-2">
            <div class="col">
              <!-- <i class="fas fa-arrow-left" @click="back"></i> -->

              <div class="text-right">
                <i class="fas fa-pen" @click="editItem"></i>&nbsp;&nbsp;&nbsp;
                <i class="fas fa-trash-alt" @click="deleteItem"></i>
              </div>

              <slot v-if="$slots.action_btn" name="action_btn"></slot>
            </div>
          </div>

          <form class="p-2 mt-2">
            <BsShowForm
              :createDef="detailDef"
              :routeDef="moduleRoute"
              :modelData="modelData1"
            >
            </BsShowForm>

            <!-- <input class="mt-2 bg-blue-500 text-xs" type="submit" value="Submit" /> -->
          </form>

          <div class="pt-2">
            <DxTabPanel>
              <DxItem
                v-for="(data, key) in relationData"
                icon="fields"
                :title="data['label']"
                :key="data['route']"
              >
                <div class="px-2">
                  {{ data["route"] }}
                  <DetailPanel
                    :routeDef="data['route']"
                    :relationDef="data"
                    :parentId="this.modelData1.id"
                    :parentRoute="this.moduleRoute"
                  >
                  </DetailPanel>
                </div>
              </DxItem>
            </DxTabPanel>
          </div>
        </div>

        <DxToast
          v-model:visible="isVisible"
          v-model:message="message"
          v-model:type="type"
        />
      </div>
    </div>
    <div v-else>
      <!-- Desktop View - START -->
      <app-layout :title="title">
        <template v-slot:sidenav> </template>

        <template v-slot:horizonav>
          <nav-bar :scId="currentProduct" scType="product"> </nav-bar>
        </template>

        <div class="mt-3 mb-2">
          <jet-back-link @click="back" class="max-w-7xl sm:px-6 lg:px-8">
            <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
            &nbsp; Go back
          </jet-back-link>
        </div>
        <!-- Breadcrumbs end -->
        <PageTitle :headerTitle="title"> </PageTitle>

        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <p class="text-xs">View the details of {{ title }} record.</p>
        </div>

        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <!-- <i class="fa fa-chevron-left" aria-hidden="true"></i> -->
          <div class="flex justify-between ...">
            <!-- Dropdown start -->
            <div class="dx-field-value">
              <DxDropDownButton
                :split-button="true"
                :use-select-mode="false"
                :items="alignments"
                :drop-down-options="{ width: 150 }"
                text=" EDIT "
                display-expr="name"
                key-expr="id"
                @button-click="editItem"
                @item-click="onItemClick"
              />
            </div>
            <!-- Dropdown  end -->

            <div>
              <span class="bg-blue-500 px-2">
                <i class="fa fa-caret-left text-white" aria-hidden="true"></i>
              </span>
              &nbsp; &nbsp; &nbsp;
              <span class="bg-blue-500 px-2">
                <i class="fa fa-caret-right text-white" aria-hidden="true"></i>
              </span>
            </div>
          </div>

          <div id="dataPanel" class="">
            <form class="mt-2">
              <BsShowForm
                :createDef="detailDef"
                :routeDef="moduleRoute"
                :modelData="modelData1"
                :prifix="slug"
              >
              </BsShowForm>

              <!-- <input class="mt-2 bg-blue-500 text-xs" type="submit" value="Submit" /> -->
            </form>

            <div class="pt-2">
              <DxTabPanel class="bg-white">
                <DxItem
                  v-for="(data, key) in relationData"
                  icon="fields"
                  :title="data['label']"
                  :key="data['route']"
                >
                  <div class="px-2">
                    <!-- {{ data['route'] }} -->
                    <DetailPanel
                      :routeDef="data['route']"
                      :relationDef="data"
                      :parentId="this.modelData1.id"
                      :parentRoute="this.moduleRoute"
                      :slug="slug"
                    >
                    </DetailPanel>
                  </div>
                </DxItem>
              </DxTabPanel>
            </div>
          </div>

          <DxToast
            v-model:visible="isVisible"
            v-model:message="message"
            v-model:type="type"
          />
        </div>
      </app-layout>
    </div>
  </div>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
/* from Include */
import DetailPanel from "@include/pages/DetailViewPanel.vue";
import BsShowForm from "@include/forms/BsShowForm.vue";
//need to move to include
import Test from "@/components/ProgressBarComponent.vue";
/* from Devextreme */
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import DxDataGrid from "devextreme-vue/data-grid";
import { DxToast } from "devextreme-vue/toast";
import { confirm, alert } from "devextreme/ui/dialog";
/* default laravel Jetstream */
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetBackLink from "@/Jetstream/BackLink.vue";
import JetButton from "@/Jetstream/Button.vue";
import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";
import NavBar from "@/Layouts/NavBar.vue";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import DxToolbar from "devextreme-vue/toolbar";
import * as Base from "@include/pages/CstmActions/DetailViewActions.js";

export default {
  props: {
    detailDef: {
      type: Array,
      default: [],
    },
    moduleRoute: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
    relationData: {
      type: Object,
      default: () => ({}),
    },
    slug: String,
    currentProduct: String,
    moduleLabel: String,
    menuActions: {
      type: Array,
      default: [],
    },
  },
  components: {
    DxDropDownButton,
    DxToolbar,
    AppLayout,
    BsShowForm,
    PageTitle,
    DxTabPanel,
    DxItem,
    Test,
    DxDataGrid,
    JetNavLink,
    JetButton,
    DxToast,
    DetailPanel,
    MobileNavigationBack,
    NavBar,
    JetBackLink,
  },
  data: function () {
    return {
      alignments: [
        //{  name: 'New', action:"create"  },
        //{  name: 'Delete', action:"delete" },
        //{  name: 'Export', action:"exportMenuGroup"},
        // {  name: 'Justify' },
      ],

      title: this.moduleLabel + " Details",
      modelData1: this.modelData,

      form: this.$inertia.form(),
      isVisible: false,
      message: "",
      type: "success",
      appbarTitle: this.moduleLabel,
    };
  },
  created() {},
  methods: {
    checkMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        console.log("CheckMobile Called: Mobile");
        return true;
      } else {
        console.log("CheckMobile Called: Desktop");
        return false;
      }
    },
    showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    },

    deleteItem() {
      let result = confirm("<i>Are you sure?</i>", "Confirm changes");
      result.then((dialogResult) => {
        if (dialogResult) {
          this.form.delete(
            route(this.moduleRoute + ".destroy", [
              this.slug,
              this.modelData.id,
            ]),
            {
              errorBag: "deleteIteam",
              onSuccess: this.showToast("Successfully Deleted", "success"),
            }
          );
        }
      });
    },
    editItem() {
      // alert(route(this.moduleRoute + ".edit",[this.slug,this.modelData.id]));
      this.form.get(
        route(this.moduleRoute + ".edit", [this.slug, this.modelData.id])
      );
    },
    onItemClick(e) {
      if (e.itemData.action == "create") {
        this.goToCreate();
      }
      if (e.itemData.action == "delete") {
        this.deleteItem();
      }
      if (e.itemData.action == "purchase") {
        this.completePurchage();
      }
      if (e.itemData.action == "raiseinvoice") {
        this.raiseInvoice();
      }
      if (e.itemData.action == "raisesalesorder") {
        this.raiseSalesOrder();
      }
      // raiseChangeOrder
      if (e.itemData.action == "raiseChangeOrder") {
        this.raiseChangeOrder();
      }
      //renewSubscription
       if (e.itemData.action == "renewSubscription") {
        this.renewSubscription();
      }
       if (e.itemData.action == "generatepdf") {
        this.generatePdf();
      }
      console.log("e.itemData.action", e.itemData);
      if (Base.A[e.itemData.action]) {
        let route = "";
        let slug = "";

        if (e.itemData.route) {
          route = e.itemData.route;
        } else {
          route = this.moduleRoute;
        }
        if (e.itemData.slug) {
          slug = e.itemData.slug;
        } else {
          slug = this.slug;
        }
        let finalRoute = "/" + slug + "/" + route;
        let param = {
          record_id: this.modelData.id,
        };
        Base.A[e.itemData.action](finalRoute, param);
      }
    },
    back() {
      window.history.back();
      //this.$inertia.get("/" + this.slug + "/" + this.moduleRoute);
    },
    completePurchage() {
      this.$inertia.post(
        route(this.moduleRoute + ".raisesubscription", this.slug),
        this.modelData
      );
    },
    raiseInvoice() {
      this.$inertia.post(
        route(this.moduleRoute + ".raiseinvoice", this.slug),
        this.modelData
      );
    },
    raiseSalesOrder() {
      this.$inertia.post(
        route(this.moduleRoute + ".raisesalesorder", this.slug),
        this.modelData
      );
    },

    raiseChangeOrder(){
       let param = {
          record_id: this.modelData.id,
        }
      this.$inertia.get(
        route(this.moduleRoute + ".raisechangeorder", this.slug),
        param
      );

     // this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/raisechangeorder");

    },

    renewSubscription(){
       this.$inertia.post(
        route(this.moduleRoute + ".renewsubscription", this.slug),
        this.modelData
      );
    },
    generatePdf(){
     
      //  let param = {
      //     record_id: this.modelData.id,
      //   }
      // this.$inertia.get(
      //   route(this.moduleRoute + ".generateinvoicepdf", this.slug),
      //   param
      // );



       const url = route(this.moduleRoute + ".generateinvoicepdf", {
      route_slug: this.slug,
      record_id: this.modelData.id , 
    });

    window.open(url, '_blank');



     
    },
    goToCreate() {

      this.$inertia.get("/" + this.slug + "/" + this.moduleRoute + "/create");
    },
    hello() {
      alert("hello");
    },
    showLoadPanel() {
      this.loadingVisible = true;
    },
    onShown() {
      setTimeout(() => {
        this.loadingVisible = false;
      }, 3000);
    },
    onHidden() {},

    formatDate(strDate) {
      var date = new Date(strDate);
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var year = date.getFullYear();
      var dateString = month + "/" + day + "/" + year;
      //console.log("BaseShow DATE ", dateString);
    },
  },

  mounted() {
    this.checkMobile();
    this.alignments = this.menuActions;
    console.log("currentProduct BASE SHOW ID ", this.currentProduct);

    //const functionName = 'getList';
    //Base.A[functionName]('/api/endpointA', { paramA: 'valueA' });
    /* .then(response => {
      // Handle the response from A.getList
      console.log("out");
    }); */
    // this.formatDate("2023-01-12T18:30:00.000Z");
    //  console.log("Detailview Panel Def", this.relationData);

    //console.log("Detailview Def", this.detailDef);this.modelData
    //console.log("Detail Data",this.modelData.id)
  },
};
</script>

 <style>
/* This is added because the settings icon was moving up - START */

.manage-margin-in-detail {
  margin-top: 4px;
}

/* This is added because the settings icon was moving up - START */

/*Panel tabs*/
#tab-contents {
  margin: 0 auto;
}

.detail,
.details-tabs-container {
  background-color: var(--white);
  border: 1px solid #ebebeb;
}

.setting-icon-margin-manage {
  margin-top: 0.6px;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}
.nav-panel-heading {
  margin-top: 10px;
}

.detail-heading {
  border-bottom: 1px solid var(--input_grey);
  padding: 2px;
}

.tabs {
  padding: 0;
  display: flex;
  border-bottom: 1px solid var(--input_grey);
  color: var(--text_grey);
}

.detail-tabs {
  margin: 0px 0px 0px 0px !important;
}

.tabs li {
  position: relative;
  background-color: var(--white);
  cursor: pointer;
  font-weight: normal;
  margin: 0px 0px 0px 0px !important;
  padding: 5px 20px !important;
  border-radius: 0px !important;
  list-style-type: none;
}

.tabs li.active {
  border-bottom: 2px solid var(--blue);
  color: #333;
  font-weight: bold;
}

.tabs li::before {
  content: "";
  visibility: hidden;
  width: 0;
  height: 2px;
  border-bottom: 1px solid var(--blue);
  background-color: var(--blue);
}

.tabs li:hover {
  background-color: #c6e3ff;
  color: var(--blue);
  font-weight: bold;
}

.tabs li:hover::before {
  visibility: visible;
  bottom: 0;
  width: 100%;
}

.panel {
  display: none;
  background: var(--white);
  box-shadow: 0 0 0 0 transparent;
  padding: 0 15px;
}

.panel.active {
  display: block;
}

.heading-row-margins {
  margin-left: 13px;
}

.breadcrumb-margin {
  margin-right: -8px;
}

.btn-back {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-top: 1px !important;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}

.btn-suspend {
  background-color: var(--orange) !important;
  color: var(--white);
  /* padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 2px; */
}

btn-suspend:hover {
  color: #fff;
  background-color: #5a6268 !important;
}

.btn-new {
  background-color: rgb(22 163 74) !important;
  color: var(--white);
  /* padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 2px; */
}

btn-new:hover {
  color: #fff;
  background-color: rgb(22 163 74) !important;
}

.btn-up {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  margin-right: 5px;
  padding-bottom: 2px;
}

btn-up:hover {
  color: #000;
}

.btn-delete {
  background-color: var(--red) !important;
  color: var(--white);
  /* padding-left: 20px;
  padding-right: 20px;
  margin-right: 5px; */
}

.btn-delete:hover {
  color: #000;
}

.demo-container .dx-fieldset:first-child {
  width: 500px;
}

.dx-popup-content > .dx-template-wrapper.custom .dx-field-value {
  width: 82px;
  padding: 5px;
}

.dx-dropdownbutton-action.dx-button .dx-button-content {
  padding-left: 12px;
  padding-right: 10px;
  background: #3b82f6;
  color: white;
}

/* .dx-button-content img.dx-icon {
    width: 24px;
    height: 24px;
  }
  .dx-button{
    max-width: 20%;
    background: #6046f0;
  } */
/* .dx-button:hover{
    max-width: 20%;
    background: #170770;
  } */
/* .toolbarItems{
    background-color: #170770;
  } */

.color {
  cursor: pointer;
  font-size: 18px;
}
.dx-button-mode-contained.dx-buttongroup-item,
.dx-button-mode-outlined.dx-buttongroup-item {
  /* padding-left: 3px; */
  padding-right: 3px;
  border-color: #0058ff4f;
}
/* .btn-delete-container {
  position: absolute;
  right: 10px;
  
  margin-top: -25px;
} */

/* .btn-suspend-container {
  position: absolute;
  right: 120px;
} */
.br {
  margin-top: 5px !important;
}
/* .createName{
  background-color: red !important;
} */
</style>